import $ from 'jquery';
export default function faq() {
    $('#question-product .accordion').click(function() {
        $("html, body").animate({
            scrollTop: $(".faq-questions-right").offset().top
        }, 0);
        if($(this).hasClass('current') == false) {
            $(this).addClass('current');
        } else {
            $(this).removeClass('current');
        }
        $('#question-product .question-active').not('current').next('.panel').removeClass('question-show');
        $('#question-product .question-active').not('current').removeClass('question-active current');
        if($(this).hasClass('current') == true) {
            if($(this).hasClass('question-active') == false) {
                $('#question-product .accordion.current').addClass('question-active');
                $('#question-product .accordion.current + .panel').addClass('question-show');
            }
        }
    });

}